import CoreMessageDispatcher from '../../core/controller/CoreMessageDispatcher';

const _dispatcher = CoreMessageDispatcher.instance();

const _start = mdr => {
    if (mdr.started) return mdr;

    mdr.el.addEventListener('click', mdr.doAction);

    mdr.started = true;
    return mdr;
};

const _stop = mdr => {
    if (!mdr.started) return mdr;

    mdr.el.removeEventListener('click', mdr.doAction);

    mdr.started = false;
    return mdr;
};

const _doAction = mdr => {
    if (!mdr.started || !mdr.event) return mdr;

    _dispatcher.emit(mdr.event, mdr.value || true);

    return mdr;
};

//

//
// Constructor
//
const ButtonMediator = (el, event, value) => {
    const mdr = {
        el: el,
        event: event,
        value: value
    };

    mdr.start = () => {
        return _start(mdr);
    };

    mdr.doAction = () => {
        return _doAction(mdr);
    };

    mdr.setEvent = event => {
        mdr.event = event;
    };

    mdr.setValue = value => {
        mdr.value = value;
    };

    mdr.stop = () => {
        return _stop(mdr);
    };

    return mdr;
};

export {ButtonMediator};
export default ButtonMediator;
